import { useState } from 'react';
import { Box, Link, Skeleton, Typography } from '@mui/material';
import { candidateProfileExplanationCellSx } from 'modules/candidate-profile/styles/candidateProfileExplanationCellSx';
import { useCandidateExplanation } from 'modules/candidate-profile/tables/CandidateExplanationsContext';

// vectorisation-service's EXPLANATION_TIMEOUT_PLACEHOLDER.
const TIMEOUT_PLACEHOLDER = '\u2014';

type CandidateProfileExplanationCellProps = {
  explanation: string | null;
  candidateProfileId?: string;
};

export const CandidateProfileExplanationCell: React.FC<
  CandidateProfileExplanationCellProps
> = ({ explanation: rowExplanation, candidateProfileId }) => {
  const [expanded, setExpanded] = useState(false);

  const { explanation: fetched, loading } =
    useCandidateExplanation(candidateProfileId);
  const value = rowExplanation ?? fetched;
  const explanation = value?.trim() === TIMEOUT_PLACEHOLDER ? null : value;

  // Stale text describes the old ranking, so the loader replaces it.
  if (loading) {
    return (
      <Box sx={candidateProfileExplanationCellSx.container}>
        <Skeleton variant="text" width="90%" />
        <Skeleton variant="text" width="70%" />
      </Box>
    );
  }

  if (!explanation) {
    return (
      <Box sx={candidateProfileExplanationCellSx.container}>
        <Typography sx={candidateProfileExplanationCellSx.missing}>
          Explanation unavailable.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={candidateProfileExplanationCellSx.container}>
      <Typography
        sx={
          expanded
            ? candidateProfileExplanationCellSx.expanded
            : candidateProfileExplanationCellSx.clamped
        }
      >
        {explanation}
      </Typography>
      <Link
        component="button"
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        sx={candidateProfileExplanationCellSx.seeMore}
      >
        {expanded ? 'See less' : 'See more'}
      </Link>
    </Box>
  );
};
